var React = require('react');

function NoDiscovered (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 11h2V5H9v6zm10-9h-6v6l2.24-2.24A5.99 5.99 0 0 1 13 15.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L19 2zM9 15h2v-2H9v2zm-8-5c0 2.21.91 4.2 2.36 5.64L1 18h6v-6l-2.24 2.24A5.99 5.99 0 0 1 7 4.35V2.26C3.55 3.15 1 6.27 1 10z","fill":"currentColor"}));
}

NoDiscovered.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = NoDiscovered;

NoDiscovered.default = NoDiscovered;
